export type { default as User } from './user';

export interface ApiErrorRequestContext {
  errorCode?: string;
  failureKind?: 'http' | 'network';
  method?: string;
  url?: string;
}

export class ApiError extends Error {
  constructor(
    public statusCode: number,
    message: string,
    public requestContext: ApiErrorRequestContext = {}
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export const DEFAULT_API_ERROR_MESSAGE = 'No se encontró el error';

export const getApiErrorMessage = (
  error: unknown,
  fallbackMessage: string
): string => {
  if (error instanceof ApiError && error.statusCode >= 500) {
    return fallbackMessage;
  }

  if (
    error instanceof Error &&
    error.message &&
    error.message !== DEFAULT_API_ERROR_MESSAGE
  ) {
    return error.message;
  }

  return fallbackMessage;
};

export type ResolvedTheme = 'light' | 'dark';
export type ThemePreference = ResolvedTheme | 'system';
export type ThemeType = ResolvedTheme;

import { ReactNode } from 'react';

export type WithChildrenProps<T = undefined> = T extends undefined
  ? {
      children?: ReactNode;
    }
  : T & {
      children?: ReactNode;
    };

export type Severity = 'success' | 'error' | 'info' | 'warning';

export type AWSResponsePresignURLType = {
  url: string;
  fileId: string;
  fileName: string;
};

export type Json = {
  [key: string | number]: number | string | boolean | null;
};

export type ResponseGeneral = {
  ok: boolean;
};
export type ResponseSchedule = {
  msg: string;
  isValidSchedule: boolean;
};
